module.exports = __webpack_public_path__ + "static/media/wave.c03dbd86.wav";